const DELIVERY_MODE = {
  SEND_NOW: 'SEND_NOW',
  SCHEDULE: 'SCHEDULE',
};

// Rendered size of a recipient-row avatar. Shared by the styles and by the <img> width/height
// attributes so the browser can reserve the box without decoding the source image first.
const AVATAR_PIXEL_SIZE = 28;

export { DELIVERY_MODE, AVATAR_PIXEL_SIZE };
